module.exports = __webpack_public_path__ + "static/media/baseline-history-24px.aafc97e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseline-history-24px.svg
// module id = 770
// module chunks = 0